import { render } from "./ReservationProduct.vue?vue&type=template&id=305f7f08"
import script from "./ReservationProduct.vue?vue&type=script&lang=js"
export * from "./ReservationProduct.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__